import React, { useEffect, useState } from 'react';
import supabase from '../../../../supabaseClient';

const SWATCHES = ['#6B1D2F', '#B58253', '#3E6B5C', '#4A5568', '#8B5E83', '#4A6B8A', '#8A6D3B', '#5C4A6B'];

function CalendarCategory({ onClose, idConfig }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState('');
  const [newColor, setNewColor] = useState(SWATCHES[0]);
  const [saving, setSaving] = useState(false);

  function loadCategories() {
    if (!idConfig) return;
    setLoading(true);
    supabase.from('calendar_categories').select('id, name, color').eq('id_configuration', idConfig).order('created_at', { ascending: true })
      .then(({ data, error }) => {
        if (error) { console.error('Błąd pobierania kategorii:', error); return; }
        setCategories(data || []);
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => { loadCategories(); }, [idConfig]);

  async function handleAdd() {
    const name = newName.trim();
    if (!name) return;
    setSaving(true);
    const { error } = await supabase.from('calendar_categories').insert({ name, color: newColor, id_configuration: idConfig });
    setSaving(false);
    if (error) { console.error('Błąd dodawania kategorii:', error); return; }
    setNewName('');
    loadCategories();
  }

  async function handleRemove(id) {
    const { error } = await supabase.from('calendar_categories').delete().eq('id', id).eq('id_configuration', idConfig);
    if (error) { console.error('Błąd usuwania kategorii:', error); return; }
    loadCategories();
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(44,20,25,0.45)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw' }}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 16, color: '#6B1D2F' }}>Kategorie akcji</div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
          {loading && <div style={{ fontSize: 12, color: '#705A5E' }}>Ładowanie…</div>}
          {!loading && categories.length === 0 && (
            <div style={{ fontSize: 12, color: '#705A5E', fontStyle: 'italic' }}>Brak kategorii — dodaj pierwszą poniżej.</div>
          )}
          {categories.map((cat) => (
            <div key={cat.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', border: '1px solid #f0f0f0', borderRadius: 8 }}>
              <div style={{ width: 14, height: 14, borderRadius: '50%', background: cat.color }} />
              <div style={{ flex: 1, fontSize: 13, fontWeight: 600 }}>{cat.name}</div>
              <button onClick={() => handleRemove(cat.id)} style={{ background: 'none', border: 'none', color: '#c0392b', fontSize: 12, cursor: 'pointer' }}>
                Usuń
              </button>
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 16 }}>
          <label style={{ display: 'block', fontSize: 12, color: '#705A5E', marginBottom: 4 }}>Nowa kategoria</label>
          <input
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            placeholder="Nazwa kategorii"
            style={{ width: '100%', boxSizing: 'border-box', padding: '9px 10px', border: '1px solid #e3d9d9', borderRadius: 8, fontSize: 14, marginBottom: 10 }}
          />
          <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
            {SWATCHES.map((sw) => (
              <div
                key={sw}
                onClick={() => setNewColor(sw)}
                style={{
                  width: 24, height: 24, borderRadius: '50%', background: sw, cursor: 'pointer',
                  border: sw === newColor ? '2px solid #2C1419' : '2px solid transparent',
                }}
              />
            ))}
          </div>
          <button onClick={handleAdd} disabled={saving} style={{
            background: '#6B1D2F', border: 'none', padding: '9px 18px', borderRadius: 8,
            fontSize: 13, fontWeight: 700, color: '#fff', cursor: saving ? 'default' : 'pointer', width: '100%',
            opacity: saving ? 0.6 : 1,
          }}>
            {saving ? 'Dodawanie…' : 'Dodaj kategorię'}
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <button onClick={onClose} style={{ background: 'none', border: '1px solid #e3d9d9', padding: '9px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, color: '#705A5E', cursor: 'pointer' }}>
            Zamknij
          </button>
        </div>
      </div>
    </div>
  );
}

export default CalendarCategory;